import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit {

  newPasswordForm: FormGroup;
  loading = false;
  submitted = false;
  success = false;
  error = false;
  errorMsg: string;
  passwordNotMatch = false;
  email: string;
  token: string;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private pageTitleService: Title,
  ) {
    this.email = this.route.snapshot.params.email;
    this.token = this.route.snapshot.params.token;
  }

  // Convenience getter for easy access to form fields
  get f() { return this.newPasswordForm.controls; }

  checkPasswordMisMatch(event: any) {
    this.passwordNotMatch = (this.f.password.value != event.target.value) ? true : false;
  }

  ngOnInit(): void {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Forgot Password');
    this.setFormControls();
  }

  setFormControls() {
    this.newPasswordForm = new FormGroup({
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(/^(.*[A-Z].*)(.*\d.*)/)
      ]),
      confirmPassword: new FormControl('', [
        Validators.required
      ])
    });
  }

  onSubmit() {
    this.submitted = true;
    this.error = false;
    this.errorMsg = "";

    // Stop here if there's form errors
    if (this.newPasswordForm.invalid) {
      return;
    }

    if (this.passwordNotMatch) {
      this.error = true;
      this.errorMsg = "Password mismatch";
      return;
    }

    this.loading = true;
    this.success = false;
    this.error = false;
    this.authService.newPassword(this.token, this.f.password.value)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data);
          if (data.success) {
            this.success = true;
            setTimeout(() => {
              this.success = false;
            }, 4000);
          } else {
            this.error = true;
            this.errorMsg = data.error.msg;
          }
          this.loading = false;
        },
        error => {
          this.error = true;
          this.loading = false;
        });
  }

}
